import { ca } from '@cian/analytics';

export function trackSpecialProjectClick(project: string) {
  ca('event', {
    action: `${project}_jk_on_map`,
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
